import {
  FETCH_USERS_FAILURE,
  FETCH_USERS_REQUEST,
  FETCH_USERS_SUCCESS,
  REFRESH_STATE,
  RESET_FORGET_PASSWORD_USER_EMAIL,
  RESET_IS_SIGNING,
  SET_FORGET_PASSWORD_USER_EMAIL,
  SET_IS_SIGNING,
  SET_LOGGEDIN_USER,
  SET_LOGGEDOUT_USER,
} from './type';

const initialState = {
  loggedInUser: null,
  token: null,
  isLoading: false,
  error: '',
  isSigning: false,
  isSubmiting: false,
  users: [],
  selecteduser: null,
  totalPage: 0,
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_LOGGEDIN_USER:
      return {
        ...state,
        loggedInUser: action.payload.user,
        token: action.payload.token,
        error: '',
        isSigning: false,
        forgetEmail: '',
      };
    case SET_LOGGEDOUT_USER:
      return {
        ...state,
        ...initialState,
      };
    case SET_FORGET_PASSWORD_USER_EMAIL:
      return {
        ...state,
        forgetEmail: action.payload,
      };
    case RESET_FORGET_PASSWORD_USER_EMAIL:
      return {
        ...state,
        forgetEmail: '',
      };
    case SET_IS_SIGNING:
      return {
        ...state,
        isSigning: true,
      };
    case RESET_IS_SIGNING:
      return {
        ...state,
        isSigning: false,
      };

    case REFRESH_STATE:
      return {
        ...state,
        token: action.payload.token,
        loggedInUser: action.payload.user,
      };
    case FETCH_USERS_REQUEST:
      return {
        ...state,
        isLoading: true,
      };
    case FETCH_USERS_SUCCESS:
      return {
        ...state,
        isLoading: false,
        users: action.payload.users,
        selecteduser: null,
        totalPage: action.payload.totalpage,
        error: '',
      };
    case FETCH_USERS_FAILURE:
      return {
        ...state,
        isLoading: false,
        users: [],
        selecteduser: null,
        error: action.payload,
      };

    default:
      return state;
  }
};

export default reducer;
